export default "<h1>Type13Code list</h1>\n<spec-app-type13-code-table [clickHandler]=\"createClickHandler()\"></spec-app-type13-code-table>";